export enum DeclinationExplanationDialogFormLabelsEnum {
  TITLE = 'Dispute Declination Explanation',
  DESCRIPTION = 'Please explain the reason for declination',
  REASON_CODE = 'Decision Reason Code',
  REASON_EXPLANATION = 'Reason for Declination',
  SUBMIT = 'Decline',
  CANCEL = 'Cancel',
}
